import { render, staticRenderFns } from "./ModernizacaoSistemasNavegantes.vue?vue&type=template&id=c37fbb7a&scoped=true"
import script from "./ModernizacaoSistemasNavegantes.vue?vue&type=script&lang=js"
export * from "./ModernizacaoSistemasNavegantes.vue?vue&type=script&lang=js"
import style0 from "./ModernizacaoSistemasNavegantes.vue?vue&type=style&index=0&id=c37fbb7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c37fbb7a",
  null
  
)

export default component.exports